import * as strDb from './strings.js'
import { FlatpickerInstance} from '../index.js'
import * as colormp from './colormaps.js'
import TileLayer from 'ol/layer/Tile'
import MVT from 'ol/format/MVT'
import TileWMS from 'ol/source/TileWMS'
import VectorTileLayer from 'ol/layer/VectorTile'
import VectorTileSource from 'ol/source/VectorTile'
import { Style, Fill, Stroke } from 'ol/style'

var GEOSERVER_PREFIX = process.env.GEOSERVER_PREFIX
var HAZARD = 'hazard'
var RISK = 'risk'
var VULNERABILITY = 'vulnerability'
var EXPOSURE = 'exposure'
var IMPACT = 'impact'

var IRRIGATED = 'irrigated'
var RAINFED = 'rainfed'
var WATER_SUPPLY = 'water_supply'

const NONE = 'none'
const MONTH = 'month'
const YEAR = 'year'

var GLOBAL = 'global'
var REGIONAL_ZA = 'regional_za'
var REGIONAL_ZW = 'regional_zw'
var WMS = 'WMS'
var VTS = 'VTS'

var FLOWLEGEND = 'flowlegend'
var MULTIFLOWLEGEND = 'multiflowlegend'
var CLASSLEGEND = 'classlegend'

var TIMESERIESPOPUP = 'timeseriespopup'
var TIMESERIESPOPUPVECTOR = 'timeseriespopupvector'
var PIECHARTPOPUP = 'piechartpopup'


export const PANSIMBABWE = [29, -19]
export const ZOOMSIMBABWE = 7
export const PANSOUTHAFRICA = [22, -30]
export const ZOOMSOUTHAFRICA = 6

var longtermCountryRiskStyle = function (feature) {
    return new Style({
        fill: new Fill({
            color: colormp.rltGetColor(feature, 'RISK_TOT')
        }),
        stroke: new Stroke({
            color: 'rgba(255,255,255,0.1)'
        })
    })
}
var asIndicatorStyle = function (feature) {
    return new Style({
        fill: new Fill({
            color: colormp.getColor(feature, 'VULNER_AS', colormp.rtl_ramp_rev, 0.2, 0.5)
        }),
        stroke: new Stroke({
            color: 'rgba(255,255,255,0.1)'
        })
    })
}
var wsIndicatorStyle = function (feature) {
    return new Style({
        fill: new Fill({
            color: colormp.getColor(feature, 'WS_value', colormp.rtl_ramp_rev, 0.3, 0.5)
        }),
        stroke: new Stroke({
            color: 'rgba(255,255,255,0.1)'
        })
    })
}

var someStyle = function (feature) {
    return new Style({
        fill: new Fill({
            color: colormp.getColor(feature, FlatpickerInstance.formatDate(FlatpickerInstance.selectedDates[0], 'Ym15'), colormp.vci_ramp, 0, 100)
        }),
        stroke: new Stroke({
            color: 'rgba(255,255,255,0.1)'
        })
    })
}

var blackStyle = function (feature) {
    return new Style({
        stroke: new Stroke({
            color: 'rgba(0,0,0,0.8)'
        })
    })
}
var adqiStyle = function (feature) {
    return new Style({
        fill: new Fill({
            color: colormp.getColor(feature, FlatpickerInstance.formatDate(FlatpickerInstance.selectedDates[0], 'Y'), colormp.adqi_ramp, 0, 1,{'-999': 'rgba(255,255,255,0.0)'})
        }),
        stroke: new Stroke({
            color: 'rgba(255,255,255,0.1)'
        })
    })
}

var ssiStyle = function (feature) {
    return new Style({
        fill: new Fill({
            color: colormp.getColor(feature, FlatpickerInstance.formatDate(FlatpickerInstance.selectedDates[0], 'Y'), colormp.adqi_ramp, 0, 2, {'-999': 'rgba(255,255,255,0.0)'})
        }),
        stroke: new Stroke({
            color: 'rgba(255,255,255,0.1)'
        })
    })
}

var hazardAttributePrefix = 'RHAZ_'
var hazardRainfedMonthlyStyle = function (feature) {
    return new Style({
        fill: new Fill({
            color: colormp.hazardGetColor(feature, hazardAttributePrefix + FlatpickerInstance.currentYear)
        }),
        stroke: new Stroke({
            color: 'rgba(255,255,255,0.1)'
        })
    })
}
var hazardCountryAttributePrefix = 'CRHAZ_'
var hazardRainfedCountryMonthlyStyle = function (feature) {
    return new Style({
        fill: new Fill({
            color: colormp.hazardGetColor(feature, hazardCountryAttributePrefix + FlatpickerInstance.currentYear)
        }),
        stroke: new Stroke({
            color: 'rgba(255,255,255,0.1)'
        })
    })
}
var hazardIrrigatedShStyle = function (feature) {
    // console.log('Y' + FlatpickerInstance.currentYear+"_"+(FlatpickerInstance.currentMonth+1))
    return new Style({
        fill: new Fill({
            color: colormp.getColor(feature, 'Y' + FlatpickerInstance.currentYear+"_"+(FlatpickerInstance.currentMonth+1),colormp.rtl_ramp,0,1)
        }),
        stroke: new Stroke({
            color: 'rgba(255,255,255,0.1)'
        })
    })
}
var hazardIrrigatedIhStyle = function (feature) {
    // console.log('Y' + FlatpickerInstance.currentYear+"_"+(FlatpickerInstance.currentMonth+1))
    return new Style({
        fill: new Fill({
            color: colormp.hazardIrrigatedIhColor(feature,'Y' + FlatpickerInstance.currentYear+"_"+(FlatpickerInstance.currentMonth+1))
        }),
        stroke: new Stroke({
            color: 'rgba(255,255,255,0.1)'
        })
    })
}

var jannaVulnerabilityStyle = function (feature) {
    return new Style({
        fill: new Fill({
            color: colormp.getColor(feature, 'TOT_VUL', colormp.rtl_ramp_rev, 0.3, 0.5, {'0': '#FFFFFF'})
        }),
        stroke: new Stroke({
            color: 'rgba(255,255,255,0.1)'
        })
    })
}

var unuHazardStyle = function (feature) {
    return new Style({
        fill: new Fill({
            color: colormp.getColor(feature, 'MEAN', colormp.rtl_ramp_rev, 0.0, 7.0)
        }),
        stroke: new Stroke({
            color: 'rgba(255,255,255,0.1)'
        })
    })
}
const createTileLayer = function ({ title = 'undefined', source = 'undefined', zIndex = 8, visible = false, maxZoom = 10 } = {}) {
    return new TileLayer({
        title: title,
        source: source,
        zIndex: zIndex,
        visible: visible,
        maxZoom: maxZoom
    })
}

export var layersGS = {
    // wms
    farmingSimbabwe: {
        title: strDb.farmingSystemZimbabwe.name,
        description: strDb.farmingSystemZimbabwe.description,
        service: WMS,
        layerTypes: [VULNERABILITY],
        dateVisibility: NONE,
        spatialExtent: REGIONAL_ZW,
        rainfedTypes: [IRRIGATED, RAINFED, WATER_SUPPLY],
        // gsLayer: 'globedrought:RSS_FarmingSystems_Zimbabwe_maskGFSAD',
        gsLayer: 'globedrought:farming_systems_zazw',
        classColorMap: {
            'Rainfed cropland': '#6ee158',
            'Irrigated cropland': '#3bb4ff'
        },
        legendType: CLASSLEGEND,
        legendTitle: 'Farming',
        panTo: PANSIMBABWE,
        zoom: ZOOMSIMBABWE
    },
    farmingSouthAfrica: {
        title: strDb.farmingSystemSouthAfrica.name,
        description: strDb.farmingSystemSouthAfrica.description,
        service: WMS,
        layerTypes: [VULNERABILITY],
        dateVisibility: NONE,
        spatialExtent: REGIONAL_ZA,
        rainfedTypes: [IRRIGATED, RAINFED, WATER_SUPPLY],
        // gsLayer: 'globedrought:RSS_FarmingSystems_SouthAfrica_maskGFSAD_ZAF_new',
        gsLayer: 'globedrought:farming_systems_zazw',
        classColorMap: {
            'Rainfed cropland': '#6ee158',
            'Irrigated cropland': '#3bb4ff'
        },
        legendType: CLASSLEGEND,
        legendTitle: 'Farming',
        panTo: PANSOUTHAFRICA,
        zoom: ZOOMSOUTHAFRICA
    },
    riskComSimbabwe: {
        title: strDb.localDroughtRiskZimbabwe.name,
        description: strDb.localDroughtRiskZimbabwe.description,
        service: WMS,
        layerTypes: [RISK],
        dateVisibility: NONE,
        spatialExtent: REGIONAL_ZW,
        rainfedTypes: [RAINFED],
        gsLayer: 'globedrought:risk_com_3',
        legendType: FLOWLEGEND,
        legendGradient: 'tg-gradient-risk-com-color',
        // legendValues: ['0.3', '', '', '', '', '', '', '', '0'],
        legendValues: ['high', '', '', '', '', '', '', '', 'low'],
        panTo: PANSIMBABWE,
        zoom: ZOOMSIMBABWE
    },
    riskRaiSimbabwe: {
        title: strDb.localDroughtRiskRainfedZimbabwe.name,
        description: strDb.localDroughtRiskRainfedZimbabwe.description,
        service: WMS,
        layerTypes: [RISK],
        dateVisibility: NONE,
        spatialExtent: REGIONAL_ZW,
        rainfedTypes: [RAINFED],
        gsLayer: 'globedrought:risk_rai_3',
        legendType: FLOWLEGEND,
        legendGradient: 'tg-gradient-risk-com-color',
        // legendValues: ['0.3', '', '', '', '', '', '', '', '0'],
        legendValues: ['high', '', '', '', '', '', '', '', 'low'],
        panTo: PANSIMBABWE,
        zoom: ZOOMSIMBABWE
    },
    droughtHazardSimbabwe: {
        title: strDb.localDroughtHazard.name,
        description: strDb.localDroughtHazard.description,
        service: VTS,
        vtsStyle: unuHazardStyle,
        layerTypes: [HAZARD],
        dateVisibility: NONE,
        spatialExtent: REGIONAL_ZW,
        rainfedTypes: [RAINFED],
        gsLayer: 'globedrought:VHI_AVERAGE_DISTRICT',
        legendType: FLOWLEGEND,
        legendGradient: 'tg-gradient-risk-com-color',
        // legendValues: ['0.3', '', '', '', '', '', '', '', '0'],
        legendValues: ['7', '', '', '', '', '', '', '', '0'],
        panTo: PANSIMBABWE,
        zoom: ZOOMSIMBABWE
    },
    riskIrrSimabwe: {
        title: strDb.localDroughtRiskIrrigatedZimbabwe.name,
        description: strDb.localDroughtRiskIrrigatedZimbabwe.description,
        service: WMS,
        layerTypes: [RISK],
        dateVisibility: NONE,
        spatialExtent: REGIONAL_ZW,
        rainfedTypes: [IRRIGATED],
        gsLayer: 'globedrought:risk_irr_3',
        legendType: FLOWLEGEND,
        legendGradient: 'tg-gradient-risk-com-color',
        // legendValues: ['0.3', '', '', '', '', '', '', '', '0'],
        legendValues: ['high', '', '', '', '', '', '', '', 'low'],
        panTo: PANSIMBABWE,
        zoom: ZOOMSIMBABWE
    },
    //
    // unu_vulnerability

    dsi: {
        title: strDb.droughtSeverityIndexStrings.name,
        description: strDb.droughtSeverityIndexStrings.description,
        service: WMS,
        layerTypes: [HAZARD],
        dateVisibility: MONTH,
        spatialExtent: GLOBAL,
        rainfedTypes: [RAINFED],
        gsLayer: 'globedrought:dsi_2003-2016',
        classColorMap: {
            exceptional: '#000000',
            extreme: '#2b1d0e',
            servere: '#ad873f',
            moderate: '#f5deb3',
            abnormal: '#e6cc68',
            'near-normal': '#eeeeee',
            none: '#247497'
        },
        legendType: CLASSLEGEND,
        legendTitle: '',
        popupType: TIMESERIESPOPUP
    },

    dsia6: {
        title: strDb.dsia6Strings.name,
        description: strDb.dsia6Strings.description,
        service: WMS,
        layerTypes: [HAZARD],
        dateVisibility: MONTH,
        spatialExtent: GLOBAL,
        rainfedTypes: [RAINFED],
        classColorMap: {
            exceptional: '#000000',
            extreme: '#2b1d0e',
            servere: '#ad873f',
            moderate: '#f5deb3',
            abnormal: '#e6cc68',
            none: '#247497'
        },
        gsLayer: 'globedrought:dsia6-2003-2016',
        legendType: CLASSLEGEND,
        legendTitle: '',
        popupType: TIMESERIESPOPUP
    },
    dsid6: {
        title: strDb.dsid6Strings.name,
        description: strDb.dsid6Strings.description,
        service: WMS,
        layerTypes: [HAZARD],
        dateVisibility: MONTH,
        spatialExtent: GLOBAL,
        rainfedTypes: [RAINFED],
        classColorMap: {
            exceptional: '#000000',
            extreme: '#2b1d0e',
            servere: '#ad873f',
            moderate: '#f5deb3',
            abnormal: '#e6cc68',
            none: '#247497'
        },
        gsLayer: 'globedrought:dsid6-2003-2016',
        legendType: CLASSLEGEND,
        legendTitle: '',
        popupType: TIMESERIESPOPUP
    },
    spei3: {
        title: strDb.spei3Strings.name,
        description: strDb.spei3Strings.description,
        service: WMS,
        layerTypes: [HAZARD],
        dateVisibility: MONTH,
        spatialExtent: GLOBAL,
        rainfedTypes: [IRRIGATED],
        gsLayer: 'globedrought:spei3-1986-2016',
        classColorMap: {
            exceptional: '#000000',
            extreme: '#2b1d0e',
            servere: '#ad873f',
            moderate: '#f5deb3',
            abnormal: '#e6cc68',
            none: '#247497'
        },
        legendType: CLASSLEGEND,
        legendTitle: '',
        popupType: TIMESERIESPOPUP

    },
    spei6: {
        title: strDb.spei6Strings.name,
        description: strDb.spei6Strings.description,
        service: WMS,
        layerTypes: [HAZARD],
        dateVisibility: MONTH,
        spatialExtent: GLOBAL,
        rainfedTypes: [IRRIGATED],
        gsLayer: 'globedrought:spei6-1986-2016',
        classColorMap: {
            exceptional: '#000000',
            extreme: '#2b1d0e',
            servere: '#ad873f',
            moderate: '#f5deb3',
            abnormal: '#e6cc68',
            none: '#247497'
        },
        legendType: CLASSLEGEND,
        legendTitle: '',
        popupType: TIMESERIESPOPUP
    },
    spei12: {
        title: strDb.spei12Strings.name,
        description: strDb.spei12Strings.description,
        service: WMS,
        layerTypes: [HAZARD],
        dateVisibility: MONTH,
        spatialExtent: GLOBAL,
        rainfedTypes: [IRRIGATED],
        gsLayer: 'globedrought:spei12-1986-2016',
        classColorMap: {
            exceptional: '#000000',
            extreme: '#2b1d0e',
            servere: '#ad873f',
            moderate: '#f5deb3',
            abnormal: '#e6cc68',
            none: '#247497'
        },
        legendType: CLASSLEGEND,
        legendTitle: '',
        popupType: TIMESERIESPOPUP
    },
    // spei12

    wasp6: {
        title: strDb.wasp6Strings.name,
        description: strDb.wasp6Strings.description,
        service: WMS,
        layerTypes: [HAZARD],
        dateVisibility: MONTH,
        spatialExtent: GLOBAL,
        rainfedTypes: [IRRIGATED],
        gsLayer: 'globedrought:wasp6-1986-2016',
        classColorMap: {
            exceptional: '#000000',
            extreme: '#2b1d0e',
            servere: '#ad873f',
            moderate: '#f5deb3',
            abnormal: '#e6cc68',
            none: '#247497'
        },
        legendType: CLASSLEGEND,
        legendTitle: '',
        popupType: TIMESERIESPOPUP
    },
    esi_total_months: {
        title: strDb.esiTotalStrings.name,
        description: strDb.esiTotalStrings.description,
        service: WMS,
        layerTypes: [IMPACT],
        dateVisibility: NONE,
        spatialExtent: GLOBAL,
        rainfedTypes: [IRRIGATED, RAINFED],
        gsLayer: 'globedrought:esi_total_months',
        legendType: FLOWLEGEND,
        legendTitle:'',
        legendGradient: 'tg-gradient-risk-com-color',
        legendValues: ['high', '', '', '', '', '', '', '', 'low']

    },

    esi_max_duration: {
        title: strDb.esiMaxStrings.name,
        description: strDb.esiMaxStrings.description,
        service: WMS,
        layerTypes: [IMPACT],
        dateVisibility: NONE,
        spatialExtent: GLOBAL,
        rainfedTypes: [IRRIGATED, RAINFED],
        gsLayer: 'globedrought:esi_max_duration',
        legendType: FLOWLEGEND,
        legendTitle: '',
        legendGradient: 'tg-gradient-risk-com-color',
        legendValues: ['high', '', '', '', '', '', '', '', 'low']
    },

    unuVulnerability: {
        title: 'Drought Vulnerability',
        description: 'Drought vulnerability is the result of a normalized and expert- weighted survey conducted by the United Nations University in 2019.',
        service: VTS,
        vtsStyle: jannaVulnerabilityStyle,
        layerTypes: [VULNERABILITY],
        dateVisibility: NONE,
        spatialExtent: REGIONAL_ZW,
        rainfedTypes: [RAINFED],
        gsLayer: 'globedrought:janna_vulnerability',
        legendType: FLOWLEGEND,
        legendGradient: 'tg-gradient-risk-com-color',
        // legendValues: ['0.5', '', '', '', '', '', '', '', '0.3'],
        legendValues: ['high', '', '', '', '', '', '', '', 'low'],
        panTo: PANSIMBABWE,
        zoom: ZOOMSIMBABWE
    },
    // spei: {
    //     class_to_color: {
    //         extreme: '#000000',
    //         servere: '#ad873f',
    //         moderate: '#f5deb3',
    //         mild: '#e6cc68',
    //         none: '#247497'
    //     }
    // }

    // vts
    hazardRainfedPixelMonthly: {
        title: strDb.hazardRainfedPixelMonthlyStrings.name,
        description: strDb.hazardRainfedPixelMonthlyStrings.description,
        service: VTS,
        gsLayer: 'globedrought:hazard_rainfed_pixel_ts',
        vtsStyle: hazardRainfedMonthlyStyle,
        layerTypes: [HAZARD],
        dateVisibility: MONTH,
        spatialExtent: GLOBAL,
        rainfedTypes: [RAINFED],
        legendType: FLOWLEGEND,
        legendGradient: 'tg-gradient-hazard-color',
        // legendValues: ['0.4', '', '', '', '0.0', '', '', '', '-0.4']
        legendValues: ['high', '', '', '', '', '', '', '', 'low'],
        popupType:TIMESERIESPOPUPVECTOR,
    },
    hazardRainfedCountryMonthly: {
        title: strDb.hazardRainfedCountryMonthlyStrings.name,
        description: strDb.hazardRainfedCountryMonthlyStrings.description,
        service: VTS,
        gsLayer: 'globedrought:hazard_rainfed_country_ts',
        vtsStyle: hazardRainfedCountryMonthlyStyle,
        layerTypes: [HAZARD],
        dateVisibility: YEAR,
        spatialExtent: GLOBAL,
        rainfedTypes: [RAINFED],
        legendType: FLOWLEGEND,
        legendGradient: 'tg-gradient-hazard-color',
        // legendValues: ['0.4', '', '', '', '0.0', '', '', '', '-0.4']
        legendValues: ['high', '', '', '', '', '', '', '', 'low'],
        popupType:TIMESERIESPOPUPVECTOR,
    },
    // vts
    // hazardRainfedPixelRhaz: {
    //     title: strDb.hazardRainfedPixelMonthlyStrings.name,
    //     description: strDb.hazardRainfedPixelMonthlyStrings.description,
    //     service: VTS,
    //     layerTypes: [HAZARD],
    //     dateVisibility: NONE,
    //     spatialExtent: GLOBAL,
    //     rainfedTypes: [WATER_SUPPLY]

    // },
    // // vts
    // hazardRainfedPixelRisk: {
    //     title: strDb.hazardRainfedPixelMonthlyStrings.name,
    //     description: strDb.hazardRainfedPixelMonthlyStrings.description,
    //     service: VTS,
    //     layerTypes: [HAZARD],
    //     dateVisibility: NONE,
    //     spatialExtent: GLOBAL,
    //     rainfedTypes: [WATER_SUPPLY]

    // },
    // vts
    // hazardRainfedPixelVulnerability: {
    //     title: strDb.hazardRainfedPixelMonthlyStrings.name,
    //     description: strDb.hazardRainfedPixelMonthlyStrings.description,
    //     service: VTS,
    //     layerTypes: [HAZARD],
    //     dateVisibility: NONE,
    //     spatialExtent: GLOBAL,
    //     rainfedTypes: [WATER_SUPPLY]

    // },
    // vts
    hazardIrrigatedSh: {
        title: strDb.hazardIrrigatedSh.name,
        description: strDb.hazardIrrigatedSh.description,
        service: VTS,
        gsLayer: 'globedrought:hazard_irrigated_sh',
        layerTypes: [HAZARD],
        dateVisibility: YEAR,
        spatialExtent: GLOBAL,
        rainfedTypes: [IRRIGATED],
        // vtsStyle: hazardIrrigatedShStyle,
        vtsStyle: hazardIrrigatedShStyle,
        legendType: FLOWLEGEND,
        legendGradient: 'tg-gradient-hazard-color',
        legendValues: ['high', '', '', '', '', '', '', '', 'low'],
    },
    hazardIrrigatedIh: {
        title: strDb.hazardIrrigatedIh.name,
        description: strDb.hazardIrrigatedIh.description,
        service: VTS,
        gsLayer: 'globedrought:hazard_irrigated_ih',
        layerTypes: [HAZARD],
        dateVisibility: YEAR,
        spatialExtent: GLOBAL,
        rainfedTypes: [IRRIGATED],
        vtsStyle: hazardIrrigatedIhStyle,
        legendType: FLOWLEGEND,
        legendGradient: 'tg-gradient-hazard-color',
        legendValues: ['high', '', '', '', '', '', '', '', 'low'],
    },
    zflVciImpact: {
        title: strDb.droughtImpactedCroplands.name,
        description: strDb.droughtImpactedCroplands.description,
        service: VTS,
        layerTypes: [IMPACT],
        dateVisibility: MONTH,
        spatialExtent: GLOBAL,
        rainfedTypes: [RAINFED, IRRIGATED], //done
        gsLayer: 'globedrought:zfl_global_vci_impact',
        vtsStyle: someStyle,
        legendType: FLOWLEGEND,
        legendGradient: 'tg-gradient-vci-impact-color',
        legendValues: ['100%', '', '', '', '50%', '', '', '', '0%']

    },
    // vts
    riskLongtermCountry: {
        title: strDb.longtermDroughtRiskStrings.name,
        description: strDb.longtermDroughtRiskStrings.description,
        service: VTS,
        layerTypes: [RISK],
        dateVisibility: NONE,
        spatialExtent: GLOBAL,
        rainfedTypes: [IRRIGATED, RAINFED],
        gsLayer: 'globedrought:risk_longterm_country',
        vtsStyle: longtermCountryRiskStyle,
        legendType: FLOWLEGEND,
        legendGradient: 'tg-gradient-hazard-color',
        // legendValues: ['0.3', '', '', '', '0.15', '', '', '', '0.0'],
        legendValues: ['high', '', '', '', '', '', '', '', 'low'],
        popupType: PIECHARTPOPUP,
        popupValues: ['RISK_IRRI', 'RISK_RF'],
        popupLabels: ['Risk Irrigation', 'Risk Rainfed']

    },
    // vts
    adqiQ50: {
        title: strDb.adqiStrings50.name,
        description: strDb.adqiStrings50.description,
        service: VTS,
        layerTypes: [HAZARD],
        dateVisibility: MONTH,
        spatialExtent: GLOBAL,
        rainfedTypes: [WATER_SUPPLY, IRRIGATED],
        gsLayer: 'globedrought:ADQI_Q50_merge_yearly',
        vtsStyle: adqiStyle,
        legendType: FLOWLEGEND,
        legendGradient: 'tg-gradient-adqi-color',
        legendValues: ['high', '', '', '', '', '', '', '', 'low']

    },
    // vts
    adqiQ80: {
        title: strDb.adqiStrings80.name,
        description: strDb.adqiStrings80.description,
        service: VTS,
        layerTypes: [HAZARD],
        dateVisibility: MONTH,
        spatialExtent: GLOBAL,
        rainfedTypes: [WATER_SUPPLY, IRRIGATED],
        gsLayer: 'globedrought:ADQI_Q80_merge_yearly',
        vtsStyle: adqiStyle,
        legendType: FLOWLEGEND,
        legendGradient: 'tg-gradient-adqi-color',
        // legendValues: ['1.0', '', '', '', 0.5, '', '', '', '0.0']
        legendValues: ['high', '', '', '', '', '', '', '', 'low'],
        popupType: TIMESERIESPOPUPVECTOR

    },
    // vts
    adqiQ80Lfm: {
        title: strDb.adqiLfmStrings80.name,
        description: strDb.adqiLfmStrings80.description,
        service: VTS,
        layerTypes: [HAZARD],
        dateVisibility: MONTH,
        spatialExtent: GLOBAL,
        rainfedTypes: [WATER_SUPPLY, IRRIGATED],
        gsLayer: 'globedrought:ADQI_Q80_LFM_WFDEI_GPCC_1986_2015_yearly',
        vtsStyle: adqiStyle,
        legendType: FLOWLEGEND,
        legendGradient: 'tg-gradient-adqi-color',
        // legendValues: ['1.0', '', '', '', 0.5, '', '', '', '0.0']
        legendValues: ['high', '', '', '', '', '', '', '', 'low'],
    },

    ssi1Gamma: {
        title: strDb.ssi1GammaStrings.name,
        description: strDb.ssi1GammaStrings.description,
        service: VTS,
        layerTypes: [HAZARD],
        dateVisibility: MONTH,
        spatialExtent: GLOBAL,
        rainfedTypes: [WATER_SUPPLY, IRRIGATED],
        gsLayer: 'globedrought:SSI1_gamma_WFDEI_GPCC_1986_2015_yearly',
        vtsStyle: ssiStyle,
        legendType: FLOWLEGEND,
        legendGradient: 'tg-gradient-adqi-color',
        // legendValues: ['1.0', '', '', '', 0.5, '', '', '', '0.0']
        legendValues: ['high', '', '', '', '', '', '', '', 'low']
    },

    ssi12Gamma: {
        title: strDb.ssi12GammaStrings.name,
        description: strDb.ssi12GammaStrings.description,
        service: VTS,
        layerTypes: [HAZARD],
        dateVisibility: MONTH,
        spatialExtent: GLOBAL,
        rainfedTypes: [WATER_SUPPLY, IRRIGATED],
        gsLayer: 'globedrought:SSI12_gamma_WFDEI_GPCC_1986_2015_yearly',
        vtsStyle: ssiStyle,
        legendType: FLOWLEGEND,
        legendGradient: 'tg-gradient-adqi-color',
        // legendValues: ['1.0', '', '', '', 0.5, '', '', '', '0.0']
        legendValues: ['high', '', '', '', '', '', '', '', 'low']
    },

    // vts
    asIndicator: {

        title: strDb.agriculturalSystemIincidcators.name,
        description: strDb.agriculturalSystemIincidcators.description,
        service: VTS,
        layerTypes: [VULNERABILITY],
        dateVisibility: NONE,
        spatialExtent: GLOBAL,
        rainfedTypes: [IRRIGATED, RAINFED],
        gsLayer: 'globedrought:AS_indicators',
        vtsStyle: asIndicatorStyle,
        legendType: FLOWLEGEND,
        legendGradient: 'tg-gradient-hazard-color',
        // legendValues: ['0.5', '', '', '', 0.4, '', '', '', '0.3']
        legendValues: ['high', '', '', '', '', '', '', '', 'low'],
    },
    wsIndicator: {

        title: strDb.waterSupplyIndicators.name,
        description: strDb.waterSupplyIndicators.description,
        service: VTS,
        layerTypes: [VULNERABILITY],
        dateVisibility: NONE,
        spatialExtent: GLOBAL,
        rainfedTypes: [WATER_SUPPLY],
        gsLayer: 'globedrought:WS_Indicators_Global',
        vtsStyle: wsIndicatorStyle,
        legendType: FLOWLEGEND,
        legendGradient: 'tg-gradient-hazard-color',
        // legendValues: ['0.5', '', '', '', 0.4, '', '', '', '0.3']
        legendValues: ['high', '', '', '', '', '', '', '', 'low'],
    }
    // vts
    // wsIndicator: {}
}

for (const [key, value] of Object.entries(layersGS)) {
    // add own name as identifier
    layersGS[key].id = key
    if (layersGS[key].service === WMS) {
        layersGS[key].source = new TileWMS({
            projection: 'equal_earth',
            url: GEOSERVER_PREFIX + '/geoserver/wms',
            params: { LAYERS: layersGS[key].gsLayer, TILED: true },
            serverType: 'geoserver',
            transition: 0,
            crossOrigin: "Anonymous"
        })
        layersGS[key].layer = createTileLayer({
            title: layersGS[key].title,
            source: layersGS[key].source
        })
    }
    if (layersGS[key].service === VTS) {
        layersGS[key].source = new VectorTileSource({
            format: new MVT(),
            crossOrigin: 'Anonymous',
            url: GEOSERVER_PREFIX + '/geoserver/gwc/service/tms/1.0.0/' + layersGS[key].gsLayer +
                '@equal_earth' + '@pbf/{z}/{x}/{-y}.pbf',
            serverType: 'geoserver',
            maxZoom: 8
        })
        layersGS[key].layer = new VectorTileLayer({
            title: layersGS[key].title,
            zIndex: 100,
            visible: false,
            maxZoom: 13,
            source: layersGS[key].source,
            style: layersGS[key].vtsStyle
        })
    }
}
